import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar-form',
  templateUrl: './app-sidebar-form.component.html'
})
export class AppSidebarFormComponent { }



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/components/app-sidebar-form/app-sidebar-form.component.ts